import { AfterViewInit, Component, Injector, OnInit } from '@angular/core';
import { LogService } from 'tnx-admin-service/slog/services';
import { ColumnSchemaBase, ComponentContextService, DataListBase, GridInfo, ModelSchema } from 'tnx-shared';
@Component({
    selector: 'log',
    templateUrl: './log.component.html',
    styleUrls: ['./log.component.scss'],
    providers: [ComponentContextService],
})
export class LogComponent extends DataListBase implements OnInit, AfterViewInit {
    searchSchema: any = {};
    searchData: any = {};
    constructor(
        protected _injector: Injector,
        protected _logDataService: LogService,
    ) {
        super(_injector);
    }

    ngOnInit() {
        this.setting.baseService = this._logDataService;
        this.setting.modelSchemas = [
            new ModelSchema({ field: 'serviceCode', name: 'Mã dịch vụ', fullName: 'Mã dịch vụ', description: 'Mã dịch vụ' }),
            new ModelSchema({ field: 'logType', name: 'Loại hành động', fullName: 'Loại hành động', description: 'Loại hành động' }),
            new ModelSchema({ field: 'metadata', name: 'Metadata', fullName: 'Metadata', description: 'Metadata' }),
            new ModelSchema({ field: 'content', name: 'Nội dung', fullName: 'Nội dung', description: 'Nội dung' }),
            new ModelSchema({ field: 'created', dataType: 'datetime', name: 'Thời gian tạo', fullName: 'Thời gian tạo', description: 'Thời gian tạo' }),
            new ModelSchema({ field: 'createdBy', name: 'Tác nhân', fullName: 'Tác nhân', description: 'Tác nhân' })
        ];

        this.setting.cols = [
            new ColumnSchemaBase({ field: 'serviceCode' }),
            new ColumnSchemaBase({ field: 'logType' }),
            new ColumnSchemaBase({ field: 'metadata', maxLengthDisplay: 20 }),
            new ColumnSchemaBase({ field: 'content', maxLengthDisplay: 20 }),
            new ColumnSchemaBase({ field: 'created' }),
            new ColumnSchemaBase({ field: 'createdBy', baseService: this._userService, displayField: 'fullNameNew' }),
        ];

        this.setting.popupSize.width = 1071;
        this.setting.popupSize.height = 600;
        this.setting.title = 'Nhật ký hệ thống';
        super.ngOnInit();
    }

    async modifyGridInfo(gridInfo: GridInfo) {
        if (gridInfo.sorts.length == 0) {
            gridInfo.sorts = [{ field: 'created', dir: -1 }];
        }
    }
}

